import React from "react";
import "../Navbar/FixProfileNavbar.css";
import "../Navbar/ProfileNavbar.css";
import { Link } from "react-router-dom";
// import { Dropdown } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import DropdownMenu, { NestedDropdownMenu } from "react-dd-menu";
import { logout } from "../../redux/root.actions";
import "../Navbar/react-dd-menu.css";
// import AccountBalanceIcon from "@material-ui/icons/AccountBalance";

// import store from "../../redux/store";
//Redux
import { connect } from "react-redux";
// import { createStructuredSelector } from "reselect"
// import { selectUserDetails } from "../../redux/homePage/homePage.selectors"
import Auth from "../../Auth/Auth";
import {permIndices} from "../../Permissions";
import { notify } from "react-notify-toast"
// import { profileIncomplete } from '../../Components-Pages/Dashboard/CollegeDashboardContents'

class CollegeMenu extends React.Component {
  // this.handleScroll = this.handleScroll.bind(this);
  // this.offset = this.props.offset ? "50px" : "0px";
  state = {
    isMenuOpen: false,
    // user: this.props.user,
    viewBookings: false,
  };
  componentDidMount = () => {
    Auth.authCheck(1 << permIndices.vi_book)
        .then((res) => {
          this.setState({ viewBookings: res.authenticated })

          if (!res.is_accept_contract && this.props.location.pathname !== "/SignContract") {
            this.props.isViewAsPersonnel
              ? this.props.history.push("/PersonnelDashboard")
              : this.props.history.push("/CollegeDashboard");
          }
        })
  }
  btn_jump_profile = (e) => {
    e.preventDefault();
    this.props.history.push("/Profile");
  };
  
  btn_jump_invoice = (e) => {
    e.preventDefault();
    this.props.history.push("/InvoiceTable");
  };

  btn_jump_finance_setting = (e) => {
    e.preventDefault();
    this.props.history.push("/FinanceSetting");
  };

  btn_jump_budget_setting = (e) => {
    e.preventDefault();
    this.props.history.push("/BudgetSetting");
  };

  btn_jump_joblist = (e) => {
    e.preventDefault();
    this.props.history.push("/CollegeJobList");
  };

  btn_jump_campus = () => {
    this.props.history.push("/Campus");
  };

  btn_jump_personnel = () => {
    this.props.history.push("/Personnel");
  };

  btn_jump_timetable = () => {
    this.props.history.push("/Timetable");
  };

  btn_jump_calendar = () => {
    this.props.history.push("/CollegeCalendar");
  };

  btn_jump_search = () => {
    this.props.history.push("/SearchTeachers");
  };

  btn_jump_favourites = () => {
    this.props.history.push("/FavouriteTeachers");
  };

  btn_jump_myhires = () => {
    this.props.history.push("/MyHires");
  }

  btn_jump_my_listings = () => {
    // if (!profileIncomplete) {
      this.props.history.push("/MyListings");
    // } else {
      // notify.show('Please add your company logo and courses delivered in your Institution Profile')
    // }
  }

  // btn_jump_new_listing = () => {
  //   this.props.history.push("/PostJobDraft");
  // }

  // jump to /PersonnelAccount if personnel is the user - lieh
  btn_jump_account = () => {
    this.props.isViewAsPersonnel
      ? this.props.history.push("/PersonnelAccount")
      : this.props.history.push("/CollegeAccount");
  };

  btn_jump_chat = () => {
    window.open("https://readyteacher.atlassian.net/servicedesk/customer/portal/6", "_blank")
  }

  btn_jump_user_manual = () => {
    this.props.history.push("/CollegeUserManual");
  }

  btn_jump_logout = () => {
    Auth.logout();
    this.props.logout();
    window.localStorage.clear();
    this.props.history.push("/LoginAsInstitution");
  };

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close = () => {
    this.setState({ isMenuOpen: false });
  };

  render() {
    // const user = store.store.getState().user.user
    const menuOptions = {
      isOpen: this.state.isMenuOpen,
      close: this.close,
      toggle: (
        <span onClick={this.toggle}>
          <i className="mdi mdi-menu"></i> Menu
        </span>
      ),
      align: "right",
      textAlign: "left",
      size: "md",
      className: "dropdown-menu-fix",
      animate: false,
    };

    const nestedMenuOptions = (menuItem, icon, onClick) => {
      return {
        toggle: (
          <div
            className={icon ? `mdi mdi-${icon} item-icon` : ""}
            onClick={onClick}
          >
            <span className={icon ? "item-icon-inner" : ""}>{menuItem}</span>
          </div>
        ),
        delay: 0,
      };
    };

    return (
      <div className="d-flex align-items-center">
        {/* added isViewAsPersonnel as check for personnel */}
        <Link
          to={
            this.props.isViewAsPersonnel
              ? "/PersonnelDashboard"
              : "/CollegeDashboard"
          }
        >
          <Icon
            name="home"
            size="large"
            className="menu-home-icon"
            title="To Dashboard"
          />
        </Link>

        <div className="drop-down-box-menuBar">
          <DropdownMenu {...menuOptions}>
            <li key="profile">
              {/* <div
                // className="mdi mdi-settings item-icon"
                onClick={this.btn_jump_profile}
                >
                <AccountBalanceIcon style={{ fontSize: 15 }} />
                <span className="item-icon-inner">Institution Profile</span>
                </div> */}
              <div
                className="mdi mdi-account-circle-outline item-icon"  //adding profile icon
                onClick={this.btn_jump_profile}
              >
                <span className="item-icon-inner">Profile</span>
              </div>
            </li>

            <NestedDropdownMenu
              {...nestedMenuOptions("Bookings", "calendar-check")}
              key="1"
            >
              <li key="calendar">
                <div
                  className={
                    this.state.viewBookings ? "" : "menu-item-disabled"
                  }
                  onClick={
                    this.state.viewBookings ? this.btn_jump_calendar : () => { }
                  }
                >
                  Calendar
                </div>
              </li>
              <li key="jobs">
                <div
                  className={
                    this.state.viewBookings ? "" : "menu-item-disabled"
                  }
                  onClick={
                    this.state.viewBookings ? this.btn_jump_joblist : () => { }
                  }
                >
                  Jobs List
                </div>
              </li>
            </NestedDropdownMenu>

            {/* <NestedDropdownMenu
              {...nestedMenuOptions("Job Listings")}
              key="0">
              <li key="my-listings">
                <div onClick={this.btn_jump_my_listings}>My Listings</div>
              </li>
              <li key="new-listing">
                <div onClick={this.btn_jump_new_listing}>New Listing</div>
              </li>
            </NestedDropdownMenu> */}

            <li key="listings">
              <div
                className="mdi mdi-briefcase item-icon"
                onClick={this.btn_jump_my_listings}
              >
                <span className="item-icon-inner">My Vacancies</span>
              </div>
            </li>

            <NestedDropdownMenu
              {...nestedMenuOptions(this.props.user?.is_childcare_centre ? "My Educators" : "My Teachers", "account-heart")}
              key="2"
            >
              <li key="search">
                <div onClick={this.btn_jump_search}>{this.props.user?.is_childcare_centre ? "Search Educators" : "Search Teachers"}</div>
              </li>
              <li key="hires">
                <div onClick={this.btn_jump_myhires}>My Hires</div>
              </li>
              <li key="favourites">
                <div onClick={this.btn_jump_favourites}>{this.props.user?.is_childcare_centre ? "Favourite Educators" : "Favourite Teachers"}</div>
              </li>
            </NestedDropdownMenu>

            <li key="invoice">
              <div
                className="mdi mdi-receipt item-icon"
                onClick={this.btn_jump_invoice}
              >
                <span className="item-icon-inner">Invoices</span>
              </div>
            </li>

            <NestedDropdownMenu
              {...nestedMenuOptions(this.props.user?.is_childcare_centre ? "Centre Settings" : "Institution Settings", "settings")}
              key="3"
            >
              <li key="campus">
                <div onClick={this.btn_jump_campus}>{this.props.user?.is_childcare_centre ? "Centres" : "Campus"}</div>
              </li>
              {this.props.isViewAsPersonnel ? null :
                <li key="personnel">
                  <div onClick={this.btn_jump_personnel}>Personnel</div>
                </li>}
              <li key="timetable">
                <div onClick={this.btn_jump_timetable}>{this.props.user?.is_childcare_centre ? "Shifts" : "Timetable"}</div>
              </li>
              {
                this.props.isViewAsPersonnel ? null :
                <li key="finance">
                  <div onClick={this.btn_jump_finance_setting}>Finance Settings</div>
                </li>
              }
              {
                this.props.isViewAsPersonnel ? null :
                <li key="budget">
                  <div onClick={this.btn_jump_budget_setting}>Budget Settings</div>
                </li>
              }
            </NestedDropdownMenu>

            <li key="account">
              <div
                className="mdi mdi-account-check item-icon"
                onClick={this.btn_jump_account}
              >
                <span className="item-icon-inner">My Account</span>
              </div>
            </li>

            <NestedDropdownMenu
              {...nestedMenuOptions(
                "Get Support",
                "chat-processing"
              )}
              key="get-support"
            >
              <li key="helpdesk">
                <div onClick={this.btn_jump_chat}>Helpdesk</div>
              </li>
              <li key="user-manual">
                <div onClick={this.btn_jump_user_manual}>User Manual</div>
              </li>
            </NestedDropdownMenu>

            <li key="logout">
              <div
                className="mdi mdi-power item-icon"
                onClick={this.btn_jump_logout}
              >
                <span className="item-icon-inner">Logout</span>
              </div>
            </li>
          </DropdownMenu>
        </div>
      </div>
    );
  }
}

// export default CollegeMenu

function mapStateToProps(state) {
  return {
    user: state.college.user,
    permissions: state.college.permissions
  };
}

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

const FixProfileNavbarWitRouter = withRouter(CollegeMenu);
export default connect(mapStateToProps, mapDispatchToProps)(FixProfileNavbarWitRouter);
